// Polyfills
require('core-js/modules/es6.array.fill').default
require('core-js/modules/es6.array.iterator').default
require('core-js/modules/es6.array.find').default
require('core-js/modules/es6.array.from').default
require('core-js/modules/es6.object.assign').default
require('core-js/modules/es6.object.keys').default
require('core-js/modules/es6.promise').default
require('core-js/modules/es6.string.includes').default
require('core-js/modules/es6.string.starts-with').default
require('core-js/modules/es6.symbol').default
require('core-js/modules/es6.set').default
require('core-js/modules/es7.array.includes').default
require('core-js/modules/es7.object.entries').default
require('core-js/modules/es7.promise.finally').default
require('core-js/modules/es7.symbol.async-iterator').default

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios').default;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });

/**
 * Load Vue.js app
 */

require('./main.js').default;
